export default __webpack_public_path__ + "static/media/hydr_drt3.53f2530c.png";